var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./OceanFreightSaleCardAllJobs.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-9a43ce38\",\"hasScoped\":false}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./OceanFreightSaleCardAllJobs.vue"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/component/ulip/OceanFreightSaleCardAllJobs.vue
// module id = 2270
// module chunks = 0